import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { api } from "../lib/api";
import { useSite } from "../context/SiteContext";

const DEFAULT_TITLE = "Lemur Quality — Compliance Consultancy Services";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/* Route-aware SEO: admin-managed seo entries (by path) override page fallbacks.
   Server-injected tags carry data-rh, so Helmet takes ownership on hydration. */
export const Seo = ({ title, description }) => {
  const { pathname } = useLocation();
  const { settings } = useSite();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    let live = true;
    api.get(`/seo/resolve?path=${encodeURIComponent(pathname)}`)
      .then((r) => { if (live) setDoc(r.data || {}); })
      .catch(() => { if (live) setDoc({}); });
    return () => { live = false; };
  }, [pathname]);

  const t = doc?.title || title || DEFAULT_TITLE;
  const d = doc?.description || description || "";
  const ogTitle = doc?.og_title || t;
  const ogDesc = doc?.og_description || d;
  const base = (settings?.canonical_base_url || "https://www.lemurquality.com").replace(/\/+$/, "");
  const canonical = doc?.canonical || (pathname === "/" ? base : `${base}${pathname}`);
  const ogImage = doc?.og_image_media_id ? `${BACKEND_URL}/api/media/${doc.og_image_media_id}` : `${base}/lemur-logo.png`;

  return (
    <Helmet>
      <title>{t}</title>
      {d && <meta name="description" content={d} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={ogTitle} />
      {ogDesc && <meta property="og:description" content={ogDesc} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Lemur Quality" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      {ogDesc && <meta name="twitter:description" content={ogDesc} />}
    </Helmet>
  );
};
